var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":function($event){return _vm.debounceAction('addInstance', { element: _vm.element })}}},[_c('div',{staticClass:"img-wrapper"},[_c('img',{staticClass:"svg-img",attrs:{"src":_vm.element.img}}),_c('span',{staticClass:"add"},[_vm._v("+")])]),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.element.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }